import styles from './style.module.scss';
import {Box, Button, Typography} from '@mui/material';

type AskLioResponsePromptProps = {
  text: string;
  className?: string;
  onClick?: () => void;
};

const AurAskLioResponsePrompt: React.FC<AskLioResponsePromptProps> = ({
  text,
  className,
  onClick,
}) => {
  return (
    <>
      <Box className={`${styles.aurBoxEnd}`}>
        <Button
          className={`${className} ${styles.aurBoxQuery} ${styles.aurQueryDashedBorder}`}
          onClick={onClick}
        >
          <Typography className={`${styles.aurBoxQueryTypography}`}>
            {text}
          </Typography>
        </Button>
      </Box>
    </>
  );
};

export default AurAskLioResponsePrompt;
